import React, {Fragment} from 'react';
import { Helmet } from 'react-helmet';
import HeroArea from "../../components/HeroArea";
import Featured from "../../components/Featured";
import AboutOne2Pay from "../../components/AboutOne2Pay";
import Paystubs from "../../components/HomePage/HomePaystubs";
import Testimonial from "../../components/Testimonial";
import PricingPlan from "../../components/PricingPlan";
import ContactUs from "../../components/ContactUs";
import Footer from "../../components/Footer";
import HowItWorks from "../../components/HomePage/HomeHowTo";
import CTA from "../../components/CTA";

import icon1 from "../../images/1.png";
import icon2 from "../../images/2.png";
import icon3 from "../../images/3.png";
import Questions from '../../components/Questions';

const featured = [
    {
        id: 1,
        icon: icon1,
        title: 'Get What You Need Now',
        body: 'High-quality pay stubs with all required information and accurate CRA calculations.',
    },
    {
        id: 2,
        icon: icon2,
        title: 'Keep It Professional',
        body: 'All the necessary information, accurate calculations, branded with your own logo.',
    },
    {
        id: 3,
        icon: icon3,
        title: 'Simple As It Gets',
        body: 'Follow our prompts & check out our step-by-step guide if you lose your way.',
    },
];

const HomePage =() => {
    return(
        <Fragment>
            <Helmet>
            <title>One Two Pay - Home</title>
            <meta name="description" content="Todos!" />
            </Helmet>
                <HeroArea/>
                <Featured featured={featured} />
                <AboutOne2Pay/>
                <Paystubs/> 
                <CTA/>          
                <PricingPlan/>  
                <Questions/>
                <HowItWorks/>
                <Testimonial/>
                <ContactUs/>
                <Footer/>
        </Fragment>
    )
};
export default HomePage;